import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  autocomplete: {
    '& .MuiOutlinedInput-root': {
      padding: '0 12px 0 12px',
    },
  },
}));
